import { Button } from 'app/components/ui/Button'
import { Input } from 'app/components/ui/Input'
import { Text } from 'app/components/ui/Text'
import React, { useState } from 'react'
import styled, { useTheme } from 'styled-components'

import { filterStatusDictionary, SponsorRequestStatusFilters } from './utils'

type Props = {
  requestsCount: number
  onFilterChanged: (filter: SponsorRequestStatusFilters) => void
  onAddSponsorRequest: () => void
}

export const SponsorRequestsTableHeader = ({
  requestsCount,
  onFilterChanged,
  onAddSponsorRequest,
}: Props): JSX.Element => {
  const theme = useTheme()

  const [activeStatusFilter, setActiveStatusFilter] =
    useState<SponsorRequestStatusFilters>('all')

  return (
    <>
      <TableHeader>
        <RequestCounter
          variant={'s16'}
          color={theme.color.primari.grigioEstra}
          weight='700'
        >
          Totale Richieste: {requestsCount}
        </RequestCounter>
        <AddRequestButtonWrapper>
          <Button onClick={onAddSponsorRequest}>Aggiungi una richiesta</Button>
        </AddRequestButtonWrapper>
        <FiltersWrapper>
          <FiltersText
            variant={'s16'}
            color={theme.color.primari.grigioEstra}
            weight='700'
          >
            Filtra per:
          </FiltersText>
          <SelectWrapper>
            <Select
              type='select'
              selectCaretSize='small'
              value={activeStatusFilter}
              onChange={(e) => {
                const value = e.target.value as SponsorRequestStatusFilters
                setActiveStatusFilter(value)
                onFilterChanged(value)
              }}
            >
              {Object.keys(filterStatusDictionary).map((filter: string) => (
                <option key={filter} value={filter}>
                  {
                    filterStatusDictionary[
                      filter as SponsorRequestStatusFilters
                    ].label
                  }
                </option>
              ))}
            </Select>
          </SelectWrapper>
        </FiltersWrapper>
      </TableHeader>
    </>
  )
}

const TableHeader = styled.div`
  max-width: 450px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 2rem;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'add-button'
    'filters';

  column-gap: 3rem;
  row-gap: 2rem;

  align-items: center;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    max-width: none;
    padding: 1rem;

    grid-template-columns: 1fr auto;
    grid-template-areas: 'filters add-button';
  }

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    grid-template-columns: auto 1fr auto;
    grid-template-areas: 'counter filters add-button';
  }
`

const RequestCounter = styled(Text)`
  grid-area: counter;

  display: none;

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    display: block;
  }
`

const FiltersWrapper = styled.div`
  grid-area: filters;

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    flex-direction: row;
    width: auto;
  }
`

const FiltersText = styled(Text)`
  margin-right: 1rem;
`

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    width: auto;
    flex-direction: column;
  }
`

const Select = styled(Input)`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    width: 250px;
  }
`

const AddRequestButtonWrapper = styled.div`
  grid-area: add-button;
  justify-self: center;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    justify-self: end;
  }
`
